import React from 'react';

import Button from '@components/uikit/Button/Button';

import type { IOther } from '../../model/items';
import style from './style.module.scss';

interface IProps {
  other: IOther;
}

const OtherCard: React.FC<IProps> = ({ other }) => {
  return (
    <div className={style.otherCard}>
      <div className={style.otherCardBody}>
        <div className={style.otherCardIcon}>{other.icon}</div>
        <h2 className={style.otherCardTitle}>{other.title}</h2>
        <div className={style.otherCardInfo}>
          <p className={style.otherCardDescription}>{other.description}</p>
        </div>
      </div>

      <div className={style.otherCardFooter}>
        <Button onClick={other.onClick} type="secondary" text={other.buttonText} />
      </div>
    </div>
  );
};

export default OtherCard;
